import { GuessBoard, GuessSettings, GuessStudent, GuessTeacher } from "@/modes/guess/GuessViews";

const guess = {
  key: "guess",
  label: "Sohbet Tahmin",
  SettingsForm: GuessSettings,
  StudentView: GuessStudent,
  BoardView: GuessBoard,
  TeacherView: GuessTeacher,
};

export default guess;
